import { TriangleAlert } from 'lucide-react'
import { useMatch } from 'react-router'
import { H3, H4 } from '@/components/sv/typographies'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useCompanyPath, useMixpanel } from '@/lib/hooks'
import { DeleteCompanySheet } from '@/routes/billing/danger-zone/delete-company-sheet'

export const BillingDangerZone = () => {
  const { navigateToPath } = useCompanyPath()
  const { track } = useMixpanel()

  const handleOpen = () => {
    track('Company Deletion Started')
    navigateToPath({
      pathname: '/billing/delete-company',
      options: { replace: true },
    })
  }

  return (
    <>
      <Card className="bg-secondary p-0 gap-0">
        <CardHeader className="px-5 pt-3 pb-1">
          <CardTitle>
            <H3 className="flex items-center gap-2 text-sm text-destructive/80">
              <TriangleAlert className="size-4" /> Danger zone
            </H3>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Card className="p-0 border-x-0 border-b-0 shadow-none">
            <CardContent className="p-0 pb-6">
              <CardHeader className="py-6 pb-0">
                <H4>Delete company</H4>
                <CardDescription>
                  Deleting this company cancels your Sevalla subscription and
                  settles your final balance immediately. This cannot be undone.
                </CardDescription>
                <CardAction>
                  <Button variant="destructive" onClick={handleOpen}>
                    Delete company
                  </Button>
                </CardAction>
              </CardHeader>
            </CardContent>
          </Card>
        </CardContent>
      </Card>

      <DeleteCompanySheet
        isOpen={Boolean(useMatch('/billing/delete-company'))}
        onClose={() =>
          navigateToPath({
            pathname: '/billing',
            options: { replace: true },
          })
        }
      />
    </>
  )
}
